export const getEndpoints = environment => {
  switch (environment) {
    case 'PRODUCTION':
      return {
        CAMPUS_API: 'https://campus-api.datacamp.com',
        MAIN_APP_DOMAIN: 'https://datacamp.com'
      };
    case 'LOCAL':
    case 'TEST':
    case 'DEVELOPMENT':
    default:
      return {
        CAMPUS_API: 'https://campus-api.datacamp-staging.com',
        MAIN_APP_DOMAIN: 'https://datacamp-staging.com'
      };
  }
};